var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageMenuActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chat_724775",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28935",
    "data-name": "Group 28935",
    transform: "translate(11.351 8.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28934",
    "data-name": "Group 28934"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39830",
    "data-name": "Path 39830",
    d: "M222.02,160h-.876v7.886a4.385,4.385,0,0,1-4.381,4.381H212.7l-2.883,2.771a2.625,2.625,0,0,1-1.821.734h3.943l2.366,3.155a.882.882,0,0,0,.692.351h.011a.879.879,0,0,0,.689-.333l2.506-3.172h3.813a2.632,2.632,0,0,0,2.629-2.629V162.629A2.632,2.632,0,0,0,222.02,160Z",
    transform: "translate(-208 -160)",
    fill: "#1481b9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28937",
    "data-name": "Group 28937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28936",
    "data-name": "Group 28936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39831",
    "data-name": "Path 39831",
    d: "M20.154,0H2.629A2.632,2.632,0,0,0,0,2.629v14.02a2.632,2.632,0,0,0,2.629,2.629H7.524l3.247,3.249A.878.878,0,0,0,12,22.537l3.389-3.26h4.765a2.632,2.632,0,0,0,2.629-2.629V2.629A2.632,2.632,0,0,0,20.154,0Zm-7.01,12.268H6.134a.876.876,0,1,1,0-1.753h7.01a.876.876,0,1,1,0,1.753Zm3.505-3.505H6.134a.876.876,0,0,1,0-1.753H16.649a.876.876,0,0,1,0,1.753Z",
    fill: "#1481b9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageMenuActiveIcon);
export default __webpack_public_path__ + "static/media/message_menu_active_icon.b8dbdbfc938ef5a2ff1407cd2ecd8670.svg";
export { ForwardRef as ReactComponent };